var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, observable, action, makeObservable } from 'mobx';
import { bound } from '../../utils/decorators/basic';
import { runtime } from '../runtime/Runtime';
import { str_replace } from '../../utils/helper/helper_string';
import { memoize } from '../../utils/mobx/decorators/memoize';
export class APIData {
    route;
    refObservablePayload;
    shallowObservablePayload;
    lastFetchEnd;
    isFetchingPromise;
    pollInterval;
    defaultPayload;
    constructor({ route, defaultValue = undefined, pollInterval }) {
        makeObservable(this);
        this.defaultPayload = defaultValue;
        this.route = route;
        if (typeof window === 'undefined') {
            this.route = `https://${runtime.runtimeHostname.subdomain}.schlaukopf.de${this.route}`;
        }
        else {
            if (runtime.runtimePermissions.hasEditFunctionality) {
                this.route = str_replace('/api/', '/api/nocache/', this.route);
            }
            else {
                if (window.preload[route]) {
                    const payload = window.preload[route].payload;
                    if (payload) {
                        this.refObservablePayload = payload;
                        this.lastFetchEnd = new Date();
                        this.isFetchingPromise = payload;
                    }
                }
            }
        }
        this.pollInterval = pollInterval;
    }
    hasAccessedDeepPayload = false;
    get deepObservablePayload() {
        return observable.box(this.refObservablePayload, { deep: true });
    }
    async refetch() {
        if (this.isFetchingPromise)
            await this.isFetchingPromise;
        await this.fetchValue();
    }
    get isAvailable() {
        return typeof this.lastFetchEnd !== 'undefined';
    }
    get triggeredIsAvailable() {
        if (!this.lastFetchEnd && !this.isFetchingPromise) {
            setTimeout(() => this.fetchValue(), 1);
        }
        return this.isAvailable;
    }
    get streamedRef() {
        this.fetchIfUnavailable();
        return this.refObservablePayload || this.defaultPayload;
    }
    get streamedDeep() {
        this.hasAccessedDeepPayload = true;
        this.fetchIfUnavailable();
        return this.deepObservablePayload.get() || this.defaultPayload;
    }
    fetchIfUnavailable() {
        if (!this.lastFetchEnd) {
            setTimeout(() => this.fetchValue(), 1);
        }
    }
    async fetchValue() {
        if (this.isFetchingPromise) {
            return await this.isFetchingPromise;
        }
        if (this.pollInterval) {
            setTimeout(this.fetchValue, this.pollInterval);
        }
        this.isFetchingPromise = this.provideFetchPromise();
        const response = await this.isFetchingPromise;
        return response.data.payload;
    }
    async provideFetchPromise() {
        const response = await runtime.axios.get(this.route, { headers: { Accept: '*/*' } }); // Accept header must match <link rel="preload" otherwise chrome won't use preload
        await runtime.runtimeScheduler.addToNextStateChange(() => {
            this.setPayload(response.data.payload);
        });
        return response;
    }
    // latestResponse;
    setPayload(payload) {
        this.refObservablePayload = payload;
        if (this.hasAccessedDeepPayload)
            this.deepObservablePayload.set(payload);
        this.isFetchingPromise = undefined;
        this.lastFetchEnd = new Date();
        // if (this.shallowObservablePayload) this.shallowObservablePayload = payload;
    }
}
__decorate([
    observable.ref
], APIData.prototype, "refObservablePayload", void 0);
__decorate([
    observable.shallow
], APIData.prototype, "shallowObservablePayload", void 0);
__decorate([
    observable.ref
], APIData.prototype, "lastFetchEnd", void 0);
__decorate([
    memoize
], APIData.prototype, "deepObservablePayload", null);
__decorate([
    bound
], APIData.prototype, "refetch", null);
__decorate([
    computed
], APIData.prototype, "isAvailable", null);
__decorate([
    computed
], APIData.prototype, "streamedRef", null);
__decorate([
    computed
], APIData.prototype, "streamedDeep", null);
__decorate([
    action.bound
], APIData.prototype, "fetchValue", null);
__decorate([
    bound
], APIData.prototype, "provideFetchPromise", null);
__decorate([
    action.bound
], APIData.prototype, "setPayload", null);
